import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import TextStyles from '../theme/text';
import { neutral } from '../theme/colors';

interface Props {
  title: string;
  status?: string;
  subtitle?: string;
}
const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    borderBottom: `1px solid ${neutral[200]}`,
    paddingBottom: 4
  },
  title: {
    '& p': {
      margin: 0
    }
  },
  subtitle: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontWeight: 300,
    color: neutral[600]
  },
  mainTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '20px',
    color: neutral[600],
    marginTop: 4
  },
  withoutSubtitle: {
    marginTop: 20
  },
  status: {
    margin: 0,
    marginRight: 20
  },
  statusLabel: {
    ...TextStyles.label1
  },
  statusText: {
    ...TextStyles.body1
  }
});

const Header = ({ title, status, subtitle }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <p className={classes.subtitle}>{subtitle}</p>
        <p className={clsx(classes.mainTitle, !subtitle && classes.withoutSubtitle)}>{title}</p>
      </div>
      {status && (
        <p className={classes.status}>
          <span className={classes.statusLabel}>Status:&nbsp;</span>
          <span className={classes.statusText}>{status}</span>
        </p>
      )}
    </div>
  );
};

export default Header;
